import axios from "axios";
import { AuthHelper } from "./AuthHelper";
import { StatusCodes } from "configurations/StatusCodes";
import { LOCAL_STORAGE_KEYS } from "configurations/Constants";

let hasSessionExpired = false;

const apiClient = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
apiClient.interceptors.request.use(
  async (config) => {
    const isPublicEndpoint = config.url?.includes("/public/");
    if (!isPublicEndpoint && !hasSessionExpired) {
      const tokenRefreshed = await AuthHelper.handleRefreshToken();
      if (!tokenRefreshed && !hasSessionExpired) {
        hasSessionExpired = true;
        AuthHelper.sessionExpired();
        window.location.href = "/login";
      }
    }
    // Add authorization header to all requests without public endpoints
    if (!isPublicEndpoint) {
      const idToken = localStorage.getItem(LOCAL_STORAGE_KEYS.ID_TOKEN);
      if (idToken) config.headers.Authorization = `Bearer ${idToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle token expiration
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const isUnauthorized =
      error.response?.status === StatusCodes.UNAUTHORIZED &&
      !error.config.url?.includes("/public/");

    if (isUnauthorized && !hasSessionExpired) {
      hasSessionExpired = true;
      AuthHelper.sessionExpired();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default apiClient;
